"use client";
import { type ReactNode, useState } from "react";
import ModalsContext from "./ModalsContext";
import React from "react";
import type { Modal } from "./types";

export function ModalsProvider({
  children,
  defaultProps,
}: {
  children: ReactNode;
  defaultProps: Record<string, unknown>;
}) {
  const [modals, setModals] = useState<Modal[]>([]);
  return (
    <ModalsContext.Provider value={setModals}>
      {children}

      {/* MODALS TRAY */}
      {modals.map((modal) =>
        React.cloneElement(modal.element, {
          key: modal.id,
          ...defaultProps,
        })
      )}
    </ModalsContext.Provider>
  );
}
